// Б.2.a: Использование вычислительных мощностей — EOT-эффект.
// В конце КАЖДОГО хода (после Ф5): владельцу юнита приходит в руку 1 случайный
// Мод из его колоды.
//
// Правила (из задания Б.2.a):
//   - Срабатывает каждый ход, пока Мод висит на юните и юнит жив.
//   - Если в колоде нет Модов — ничего не приходит, эффект пропадает в этот ход
//     (продолжит срабатывать следующим ходом, если в колоде появится Мод).
//   - Если рука переполнена (10) — карта добирается и сразу сгорает (стандартное
//     поведение движка для добора в полную руку).
//   - Случайный выбор — равновероятный среди всех Модов в колоде на момент
//     срабатывания.

export const MOD_ID = 'syn_ispolzovanie_vychislitelnyh_mo';

export function vychMoschnostiEot(state, ownerIdx, carrier) {
  const p = state.players[ownerIdx];
  const modsInDeck = p.deck.filter(c => c.type === 'mod');
  if (modsInDeck.length === 0) {
    state.log.add(`💻 ${carrier.name_ru} [${p.name}]: Выч. мощности — в колоде нет Модов`);
    return;
  }
  const idx = state.rng.int(modsInDeck.length);
  const card = modsInDeck[idx];
  const deckIdx = p.deck.indexOf(card);
  if (deckIdx >= 0) p.deck.splice(deckIdx, 1);
  if (p.hand.length >= 10) {
    p.discard.push(card);
    state.log.add(`💻 ${carrier.name_ru} [${p.name}]: Выч. мощности — ${card.name_ru} сгорает (рука полна)`);
  } else {
    p.hand.push(card);
    state.log.add(`💻 ${carrier.name_ru} [${p.name}]: Выч. мощности — +${card.name_ru} в руку`);
  }
}
